import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

const ShinchanViewer: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scroll = useRef<number>(0);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, container.clientWidth / container.clientHeight, 0.1, 1000);
    camera.position.z = 3;
    camera.position.y = 0.9;
    const renderer = new THREE.WebGLRenderer();
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(container.clientWidth, container.clientHeight);
    container.appendChild(renderer.domElement);
    renderer.setClearColor(new THREE.Color(200 / 255, 255 / 255, 255 / 255),0);
    const loader = new GLTFLoader();
    loader.load('/3dmodels/shin_chan/scene.gltf', (gltf) => {
        console.log(gltf);
      const model = gltf.scene;
      const textureLoader = new THREE.TextureLoader();
      const texture = textureLoader.load('/3dmodels/shin_chan/textures/material_baseColor.png');
      const uvMapGeometry = new THREE.PlaneGeometry(1, 1);
      const uvMapMaterial = new THREE.MeshBasicMaterial({ map: texture, transparent: true });
      const uvMapMesh = new THREE.Mesh(uvMapGeometry, uvMapMaterial);
      uvMapMesh.position.set(0, 0, 0); 
      uvMapMesh.rotation.set(0, 0, 0); 
    model.scale.set(1, 1, 1);
    model.rotateY(4.8);
      scene.add(model);
      const ambientLight = new THREE.AmbientLight(0xffffff00, 1);
      scene.add(ambientLight);

      const directionalLight = new THREE.DirectionalLight(0x5522ff, 1.5);
      directionalLight.position.set(1, 1, 1);
      scene.add(directionalLight);
       const animate = () => {
        renderer.render(scene, camera);
        requestAnimationFrame(animate);
      };
      animate();
    });

    const handleScroll = () => {
      scroll.current = window.scrollY;
      scene.rotation.y = scroll.current /25;  
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      container.removeChild(renderer.domElement);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <div ref={containerRef} style={{ width: '100vw', height: '100vh' }} className='flex justify-center z-20 overflow-visible' />;
};

export default ShinchanViewer;
